module.exports = __webpack_public_path__ + "img/cvvcode.eab7534c.svg";